// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';

@Component({
    selector: 'page-details-section-qa-readability',
    standalone: false,
    template: `
        <div class="d-flex align-items-center mb-2">
            <span class="fa-2x fa-fw fas fa-eye mr-2 text-link mt-3" aria-hidden="true"></span>
            <h2 class="font-weight-300 mb-0" translate>
                Readability
            </h2>
        </div>
        <div class="card panel-monsido-card mt-2">
            <div class="card-body">
                <table class="table table-hover table-fixed">
                    <thead class="hidden">
                    <tr>
                        <th class="col-13 col-lg-9">&nbsp;</th>
                        <th class="col-37 col-lg-39">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <span class="ml-2 fas fa-eye fa-lg fa-fw mr-2" aria-hidden="true"></span>
                            <span translate>Readability Score</span>
                        </td>
                        <td class="text-v-middle">
                            <span class="readability-score">{{ (pageObj.readability || 0) | monNumber }}</span>
                            <span>
                                <ng-container *ngIf="pageObj.readability_level !== 'na'">
                                    {{ pageObj.readability_level | translateReadability:domain.features.readability_test }}
                                </ng-container>
                                <ng-container *ngIf="pageObj.readability_level === 'na'">
                                    {{ (pageObj.readability_reason || pageObj.readability_level) | translateReadability:domain.features.readability_test }}
                                </ng-container>
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span class="ml-2 fas fa-language fa-lg fa-fw mr-2" aria-hidden="true"></span>
                            <span translate>Word Count</span>
                        </td>
                        <td class="text-v-middle">
                            {{ chooseCount() | monNumber }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    `,
})
export class PageDetailsSectionQaReadabilityComponent implements OnInit {
    @Input() pageObj: any = {};

    domain: any;

    constructor (
        private sessionService: SessionService,
    ) {}

    ngOnInit (): void {
        this.domain = this.sessionService.domain;
    }

    chooseCount (): number {
        if (this.pageObj.type === 'pdf') {
            return this.pageObj.readability_words_count === 0 ? this.pageObj.words_count : this.pageObj.readability_words_count;
        } else {
            return this.pageObj.readability_words_count;
        }
    }
}
